// Historial unificado de precios acordados (FRA-340) — la parte pura.
// Los tres precios acordados del sistema (tarifa del proveedor, comisión de
// planner, gasto recurrente) comparten forma de registro y forma de leerse.
// La escritura con batch vive en
// utils/precioAcordado.js; el componente de lectura en
// components/shared/HistorialPrecios.js. Aquí solo hay funciones sin
// Firestore ni React, como utils/costos.js.

// Forma canónica del registro. Es la misma que ya usaba la tarifa del
// proveedor, para que sus historiales existentes se lean sin traducción.
export function registroPrecio({
  monto,
  montoAnterior = 0,
  notas = null,
  uid,
  nombre = "",
  ahora,
}) {
  return {
    monto: Number(monto) > 0 ? Number(monto) : 0,
    montoAnterior: Number(montoAnterior) > 0 ? Number(montoAnterior) : 0,
    fecha: ahora,
    setBy: uid,
    setByName: nombre || "",
    notas: notas || null,
  };
}

const ms = (v) => {
  if (v == null) return null;
  if (typeof v.toMillis === "function") return v.toMillis();
  if (typeof v.toDate === "function") return v.toDate().getTime();
  if (v instanceof Date) return v.getTime();
  return typeof v === "number" ? v : null;
};

// Enriquece un historial ordenado DESC por fecha (como llega de Firestore)
// con lo que la línea de tiempo pinta: salto en pesos, salto porcentual y
// meses transcurridos desde el cambio previo. El salto es null cuando no
// hay contra qué comparar (registro inicial o precio eliminado) — ahí no se
// pinta porcentaje.
export function conSaltos(historial) {
  const lista = Array.isArray(historial) ? historial : [];
  return lista.map((h, idx) => {
    const previo = lista[idx + 1] || null;
    const monto = Number(h.monto) || 0;
    const anterior = Number(h.montoAnterior) || 0;
    const comparable = monto > 0 && anterior > 0;
    const a = ms(h.fecha);
    const b = previo ? ms(previo.fecha) : null;
    return {
      ...h,
      salto: comparable ? monto - anterior : null,
      saltoPct: comparable ? ((monto - anterior) / anterior) * 100 : null,
      mesesDesdeAnterior:
        a != null && b != null
          ? Math.round((a - b) / (1000 * 60 * 60 * 24 * 30))
          : null,
    };
  });
}

const fmtDefault = (v) =>
  "$" + (Number(v) || 0).toLocaleString("es-MX", { maximumFractionDigits: 2 });

// "Tarifa inicial: $8,000" / "$8,000 → $9,000" / "Tarifa eliminada".
// Las etiquetas cambian por caso (tarifa, comisión, costo, gasto); la
// estructura de la frase no.
export function describeCambioPrecio(
  h,
  { inicial = "Precio inicial", eliminado = "Precio eliminado" } = {},
  fmt = fmtDefault
) {
  const monto = Number(h?.monto) || 0;
  const anterior = Number(h?.montoAnterior) || 0;
  if (monto === 0) return eliminado;
  if (anterior === 0) return `${inicial}: ${fmt(monto)}`;
  return `${fmt(anterior)} → ${fmt(monto)}`;
}
